const openSettings = () => {
	// Do nothing
};

export default openSettings;
